import { useState, useCallback } from "react";
import apiFetch from "@wordpress/api-fetch";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(async (requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await apiFetch({
        path: requestConfig.url,
        //TODO fix on production
        // headers: {
        //   "X-WP-Nonce": window.wpApiSettings.nonce,
        // },
        method: requestConfig.method ? requestConfig.method : "GET",
        data: requestConfig.body ? requestConfig.body : null,
      });

      applyData(response);
    } catch (err) {
      setError(!!err.message ? err.message : "خطایی نامشخص رخ داد!");
    }
    setIsLoading(false);
  }, []);

  const setErrorNull = useCallback(() => {
    setError(null);
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
    setErrorNull,
  };
};

export default useHttp;
